import { createElement } from 'react'
import type { ReactElement } from 'react'
import Catalog from './Catalog'
import Activity from './Activity'
import Clusters from './clusters/Clusters'
import FlavorView from './FlavorView'
import InstallIso from './InstallIso'
import NodeView from './NodeView'
import QuotaTiers from './QuotaTiers'
import QuotaTierView from './QuotaTierView'
import Reports from './Reports'
import Review from './Review'
import TeamList from './TeamList'
import TeamView from './TeamView'
import UserList from './UserList'
import UserView from './UserView'
import VmList from './VmList'
import VmView from './VmView'
import type { World } from './model'

export type ScreenProps = { world: World; query: string; loading: boolean }
export type ScreenRoute = {
  path: string
  render: (props: ScreenProps) => ReactElement
  /** 최고 관리자의 화면(F-38). 관리자에게는 없는 경로다. */
  top?: true
}

// 경로와 화면의 단일 원본. 내비게이션과 렌더링 계약 테스트도 이 목록을 읽는다.
export const SCREEN_ROUTES: readonly ScreenRoute[] = [
  { path: '/', render: ({ world, loading }) => createElement(Review, { world, loading }), top: true },
  { path: '/clusters', render: ({ world, query, loading }) => createElement(Clusters, { world, query, loading }), top: true },
  { path: '/activity', render: () => createElement(Activity), top: true },
  { path: '/reports', render: () => createElement(Reports), top: true },
  { path: '/users', render: ({ world, query }) => createElement(UserList, { world, query }) },
  { path: '/signups', render: ({ world, loading }) => createElement(Review, { world, loading, scope: 'signups' }), top: true },
  { path: '/users/:id', render: ({ world }) => createElement(UserView, { world }) },
  { path: '/teams', render: ({ world, query }) => createElement(TeamList, { world, query }) },
  { path: '/teams/:id', render: ({ world }) => createElement(TeamView, { world }) },
  { path: '/quota-tiers', render: ({ world, query }) => createElement(QuotaTiers, { world, query }), top: true },
  { path: '/quota-tiers/:id', render: ({ world }) => createElement(QuotaTierView, { world }), top: true },
  { path: '/vms', render: ({ world, query }) => createElement(VmList, { world, query }) },
  { path: '/vms/:id', render: ({ world }) => createElement(VmView, { world }) },
  { path: '/catalog', render: ({ query }) => createElement(Catalog, { query }), top: true },
  { path: '/catalog/flavors/:id', render: () => createElement(FlavorView), top: true },
  { path: '/nodes/:id', render: ({ world }) => createElement(NodeView, { world }), top: true },
  { path: '/install/iso', render: () => createElement(InstallIso), top: true },
]

export const ROUTES = SCREEN_ROUTES.map(({ path }) => path)
